import React from 'react';
import { ModalContent } from './modalContent';
import { SimpleModal } from '@livable/saas-react-components';
export const RefundCreditInvoiceModal = _ref => {
  let isOpen = _ref.isOpen,
    currentInvoice = _ref.currentInvoice,
    handleOpenExternal = _ref.handleOpenExternal,
    reloadData = _ref.reloadData,
    handleCloseExternal = _ref.handleCloseExternal,
    setShowInvoice = _ref.setShowInvoice;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    isOpen: isOpen,
    trigger: false,
    title: "Refund/Credit invoice",
    handleOpen: handleOpenExternal,
    handleClose: handleCloseExternal
  }, /*#__PURE__*/React.createElement(ModalContent, {
    currentInvoice: currentInvoice,
    reloadData: reloadData,
    setShowInvoice: setShowInvoice
  }));
};